function addCommasToNumber(numberWithoutCommas) {
    return numberWithoutCommas.toLocaleString();
}
export {addCommasToNumber};